import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable} from 'rxjs';
import { APP_CONFIG, Settings } from 'src/app/config/settings';
import { StandardDocumentMetaData } from 'src/app/recruiting/candidates/new-profile/candidate-uploaded-profile-document/models/standard-documents-meta-data';
import { combine } from 'src/app/shared/utilities/route';

@Injectable({ providedIn: 'root' })
export class CandidateUploadedProfileDocumentService {
    private readonly coreApiPath: string;

    constructor(@Inject(APP_CONFIG) settings: Settings, private readonly http: HttpClient) {
        this.coreApiPath = combine(settings.coreAPIUrl, 'ayanova');
    }

    getProfileUnsignedUploadedDocuments(candidateId: number): Observable<StandardDocumentMetaData> {        
        const url = `${this.coreApiPath}/Candidate/${candidateId}/unsigned-candidate-documents`;
        return this.http.get<StandardDocumentMetaData>(url);                       
    }  
}
